'use client';

export default function ErrorMessage({ reset }: { reset?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] gap-6 py-24 px-[6vw] text-center">
      <p className="font-serif text-2xl text-text">Ocorreu um erro.</p>
      {reset && (
        <button
          onClick={reset}
          className="font-sans text-sm font-bold tracking-widest uppercase bg-primary text-white px-6 py-3 hover:bg-[var(--color-primary-dark)] transition-colors cursor-pointer"
        >
          Tentar novamente
        </button>
      )}
    </div>
  );
}
